import { render, staticRenderFns } from "./LdConfirmationContainer.vue?vue&type=template&id=5f5f501b"
import script from "./LdConfirmationContainer.vue?vue&type=script&lang=js"
export * from "./LdConfirmationContainer.vue?vue&type=script&lang=js"
import style0 from "./LdConfirmationContainer.vue?vue&type=style&index=0&id=5f5f501b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports